import { live, LiveController } from "@camertron/live-component";

type LetterComponentProps = {
  on_done_flipping?: () => void
}

@live("Wordle::LetterComponent")
export class LetterComponent extends LiveController<LetterComponentProps> {
  on_done_flipping() {
    this.props.on_done_flipping?.();
  }

  on_click() {
    console.log("click");
  }
}
